<div class="flex min-h-screen bg-gray-100">
  <app-sidebar></app-sidebar>
  <main class="flex-1 p-6 overflow-y-auto sm:ml-64">
    <router-outlet></router-outlet>
  </main>
</div>
